import React from 'react'
import { Container, Row, Col } from 'reactstrap'
import { useStaticQuery, graphql } from 'gatsby'
import Image from '../../../components/image'
import { AboutBannerWrap } from './about-banner-area.stc'

const AboutBannerArea = () => {
	const aboutBannerData = useStaticQuery(graphql`
        query AboutBannerQuery {
            aboutJson(jsonId: {eq: "about-page-banner"}) {
				banner {
					childImageSharp {
						gatsbyImageData(width: 1260, height: 585, layout: CONSTRAINED, quality: 100, placeholder: TRACED_SVG)
					}
				}
            }
        }      
    `);

	return (
		<AboutBannerWrap>
			<Container>
				<Row>
					<Col lg={12}>
						<Image src={aboutBannerData.aboutJson.banner} alt="about banner" />
					</Col>
				</Row>
			</Container>
		</AboutBannerWrap>
	)
}

export default AboutBannerArea
